import { render } from "./viewN2f.vue?vue&type=template&id=48d71857"
import script from "./viewN2f.vue?vue&type=script&lang=ts"
export * from "./viewN2f.vue?vue&type=script&lang=ts"
script.render = render

export default script